export default {
    dependencies: ['$element', 'xhrservice', 'reqwest', 'trackingservice'],
    callable(ele, xhrservice, reqwest, trackingService) {
        let form;
        let submitButton;

        const onSendFailed = function() {
            submitButton.classList.remove('inprogress');

            const mailInput = form.elements.to;
            mailInput
                .closest('[data-input-wrapper]')
                .classList.add('invalid', 'input--is-invalid');
        };

        const onSendSucceeded = function() {
            submitButton.classList.remove('inprogress');

            form.elements.message.value = '';

            const mailInput = form.elements.to;
            mailInput.value = '';
            mailInput
                .closest('[data-input-wrapper]')
                .classList.remove('invalid', 'input--is-invalid');

            const feedbackArea = ele.querySelector(
                '[data-tip-a-friend-feedback]'
            );
            feedbackArea.textContent = 'Meldingen ble sendt';
            trackingService.trackEvent(
                'share.tip-a-friend.sent',
                'success',
                'activity'
            );
            feedbackArea.classList.remove('hidden', 'u-display-none');
            window.setTimeout(() => {
                feedbackArea.textContent = '';
                feedbackArea.classList.add('hidden', 'u-display-none');
                ele.classList.add('hidden', 'u-display-none');
            }, 2000);
        };

        const submitHandler = function(e) {
            e.preventDefault();

            submitButton.classList.add('inprogress', 'button--in-progress');

            const formData = reqwest.serialize(form, { type: 'map' });

            xhrservice
                .request({
                    method: 'POST',
                    url: '/tipAFriend/xhr.json',
                    data: formData,
                })
                .then(onSendSucceeded, onSendFailed);
        };

        const init = function() {
            form = ele.querySelector('form');
            submitButton = ele.querySelector('[data-submit-tip-a-friend]');

            form.addEventListener('submit', submitHandler);
        };

        return init();
    },
};



// WEBPACK FOOTER //
// ./controllers/tipafriend.js